import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeMessage } from "../../redux/actions/messagesActions";
import { IMessage } from "../../redux/reducers/messagesReducer";
import { selectMessagesQueue } from "../../redux/selectors/messages";

import Toast from "../toast";

const InfoMessages = () => {
  const dispatch = useDispatch();
  const messages = useSelector(selectMessagesQueue);
  const [currentMessage, setCurrentMessage] = useState<IMessage | undefined>(messages[0]);

  useEffect(() => {
    if (messages[0]) {
      setCurrentMessage(messages[0]);
    } else {
      setCurrentMessage(undefined);
    }
  }, [messages]);

  const onClose = (message: IMessage) => {
    dispatch(removeMessage(message));
  };

  if (!currentMessage) return null;
  return <Toast message={currentMessage} onClose={onClose} />;
};

export default InfoMessages;
